// TSS vite/04 §"Endpoint paths".
// No leading slash — axios joins baseURL + url with a single slash.
//
// The human surface of the breakdown. There is a parallel `/agent/breakdown/*`
// family and the panel uses NONE of it: those routes take a Bearer token, and a
// person with a session should never have to mint an agent credential to do
// their own job. The two doors call the same managers anyway.
//
// AND TWO OF THESE HAVE NO AGENT DOOR AT ALL, which is the design and not an
// oversight: agreeing a tier and authorizing tasks demand a human session. An
// agent prepares; a person decides.
export const breakdownPaths = {
    // Content, revision, state, agreements, dependencies, `frozen` and
    // `ready_to_agree.missing` — everything the agreement screen needs, in one
    // response, computed by the backend.
    breakdown: (tierId) => `admin/tiers/${tierId}/breakdown`,

    // The tier's task proposals, paginated.
    tasks: (tierId) => `admin/tiers/${tierId}/tasks`,

    // Human only. `tiers:agree`.
    agreement: (tierId) => `admin/tiers/${tierId}/agreement`,
    // Authorizing ONE task. Under /tasks in the URL, but it is the same
    // authorization as the batch — same manager, same rules, same signature —
    // so it lives with the batch and not with task editing.
    promote: (taskId) => `admin/tasks/${taskId}/promote`,

    // A batch of 1 to 50. `tasks:write`.
    proposals: (tierId) => `admin/tiers/${tierId}/task-proposals`,

    // Human only, atomic. `tasks:authorize`.
    authorizations: (tierId) => `admin/tiers/${tierId}/task-authorizations`,
};
